import { Canvas } from 'fabric';

/**
 * Set a fabric canvas's DISPLAY size to the largest box of `aspectRatio` that fits
 * within `boxWidth` × `boxHeight` (contain-fit, never stretched), using fabric's
 * `cssOnly` setDimensions. The canvas's INTERNAL resolution is left untouched, so
 * rendering stays crisp and pointer mapping stays correct; the caller centers the
 * canvas (e.g. with flexbox).
 *
 * Pure helper shared by PracticeTrainer and the classroom canvas renderer — each owns
 * its own resize trigger (a ResizeObserver, or the `fabricCanvasFit` directive); this
 * is just the common math + `setDimensions` call.
 *
 * @param aspectRatio width / height of the logical canvas (e.g. 16/9).
 */
export function fitCanvasToBox(
    canvas: Canvas,
    boxWidth: number,
    boxHeight: number,
    aspectRatio: number
): void {
    if (boxWidth <= 0 || boxHeight <= 0 || aspectRatio <= 0) return;

    let width = boxWidth;
    let height = width / aspectRatio;
    if (height > boxHeight) {
        height = boxHeight;
        width = height * aspectRatio;
    }

    canvas.setDimensions(
        { width: Math.round(width), height: Math.round(height) },
        { cssOnly: true }
    );
}
